import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { ConfirmationDialog } from './confirmation-dialog/confirmation-dialog';
import { Footer } from './headers-footers/footer/footer';
import { Header } from './headers-footers/header/header';
import { RouterModule } from '@angular/router';
import { Wrapper } from './wrapper/wrapper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { PhoneInput } from './inputs/phone-input/phone-input';
import { TomSelectComponent } from './inputs/tom-select/tom-select.component';
import { TerminalLogComponent } from './terminal/terminal-log.component';
import { VariableParserInputComponent } from './inputs/variable-parser-input/variable-parser-input';
import { AutocompleteSelectComponent } from './inputs/autocomplete-select/autocomplete-select.component';
import { VerticalSplitResizeDirective } from './directives/vertical-split-resize';
import { SettingsShellComponent } from './settings/settings-shell/settings-shell';
import { Chat } from './chat/chat';
import { ImageCropUploadComponent } from './image-crop-upload/image-crop-upload.component';
import { SearchBarComponent } from './search-filter-pagination/search-bar/search-bar.component';
import { RecordList } from './list-components/record-list/record-list';
import { DatePickerInputComponent } from './inputs/date-picker-input/date-picker-input.component';
import { UtcToLocalPipe } from './pipes/utc-to-local.pipe';
import { LocalDateTimePipe } from './pipes/local-date-time.pipe';
import { RelativeDatePipe } from './pipes/relative-date-pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { SharedActivitySchedulerModal } from './activity-scheduler-modal/activity-scheduler-modal';
import { PaginationComponent } from './search-filter-pagination/pagination.component/pagination.component';
import { SafeSvgPipe } from './pipes/safe-svg.pipe';
import { ProductVariantPicker } from './inputs/product-variant-picker/product-variant-picker';
import { PipelineTracker } from './pipeline-tracker/pipeline-tracker';
import { TaxSelector } from './inputs/tax-selector/tax-selector';
import { MoneyInput } from './inputs/money-input/money-input';
import { FloatingDropdownComponent } from './dropdowns/floating-dropdown/floating-dropdown.component';
import { TabulatedForm } from './tabulated-form/tabulated-form';
import { PageBackButtonComponent } from './navigation/page-back-button/page-back-button';
import { AnalyticDistributionInput } from './inputs/analytic-distribution-input/analytic-distribution-input';
import { PartnersSelect } from './inputs/partners-select/partners-select';
import { BusinessDocumentEvents } from './business-document/business-document-events/business-document-events';
import { CountrySelect } from './inputs/country-select/country-select';
import { RegionSelect } from './inputs/region-select/region-select';
import { CitySelect } from './inputs/city-select/city-select';
import { AddressAutocomplete } from './inputs/address-autocomplete/address-autocomplete';
import { AnalyticDistributionModelNewModal } from '../apps/configuration/accounting-finance/analytic-distribution-models/new-modal/new-modal';
import { AutosaveStatus } from './autosave-status/autosave-status';
import { CurrencySelect } from './inputs/currency-select/currency-select';
import { VerificationDrawer } from './verification-drawer/verification-drawer';
import { BusinessDocumentView } from './business-document/business-document-view/business-document-view';
import { ListSelectionDirective } from './directives/list-selection.directive';
import { TableCellOverflowTitleDirective } from './directives/table-cell-overflow-title.directive';
import { TimezoneSelect } from './inputs/timezone-select/timezone-select';
import { BusinessDocumentKanban } from './business-document/business-document-kanban/business-document-kanban';
import { BusinessDocumentViewToggle } from './business-document/business-document-view-toggle/business-document-view-toggle';
import { LinkedRecordStatus } from './linked-record-status/linked-record-status';
import { ViewModeToggle } from './view-mode-toggle/view-mode-toggle';
import { Alerts } from './alerts/alerts';
import { GlobalAlert } from './alerts/global-alert';
import { OpenRouterLinkInNewTab } from './open-router-link-in-new-tab';
import { EmployeeGroupMemberFiltersInput } from './inputs/employee-group-member-filters-input/employee-group-member-filters-input';
import { BusinessDocumentPipelinePicker } from './business-document/business-document-pipeline-picker/business-document-pipeline-picker';
import { ProductLines } from './business-document/product-lines/product-lines';
import { BusinessDocumentWrapper } from './business-document/business-document-wrapper/business-document-wrapper';
import { BusinessDocumentNextButtons } from './business-document/business-document-next-buttons/business-document-next-buttons';
import { BusinessDocumentContributorModal } from './business-document/business-document-contributor-modal/business-document-contributor-modal';
import { WidgetAndGraphsModule } from '../core/widget-and-graphs/widget-and-graphs-module';
import { RealtimeToasts } from './realtime-toasts/realtime-toasts';
import { ProjectCard } from './list-components/cards/project-card';
import { AppMenu } from './navigation/app-menu/app-menu';
import { BusinessDocumentEmailDrawer } from './business-document/business-document-email-drawer/business-document-email-drawer';
import { BusinessDocumentChatDrawer } from './business-document/business-document-chat-drawer/business-document-chat-drawer';
import { MessageList } from './email/message-list/message-list';
import { MessageView } from './email/message-view/message-view';
import { AiChat } from './ai/ai-chat/ai-chat';
import { AiComposer } from './ai/ai-composer/ai-composer';
import { AiModelConnectionForm } from './ai/ai-model-connection-form/ai-model-connection-form';
import { ProductItemPicker } from './inputs/product-item-picker/product-item-picker';
import { AiMarkdownPipe } from './pipes/ai-markdown-pipe';
import { AiMessage } from './ai/ai-message/ai-message';
import { AiConversationList } from './ai/ai-conversation-list/ai-conversation-list';
import { AiModelConnectionsPage } from './ai/ai-model-connections-page/ai-model-connections-page';
import { RqlSelect } from './inputs/rql-select/rql-select';
import { JournalEntryLines } from './business-document/journal-entry-lines/journal-entry-lines';
import { Information } from './information/information';
import { InformationPanel } from './information/information-panel';
import { SingleImageInput } from './inputs/single-image-input/single-image-input';




@NgModule({
  declarations: [
    Footer,
    Header,
    Wrapper,
    PhoneInput,
    TomSelectComponent,
    AutocompleteSelectComponent,
    RqlSelect,
    TerminalLogComponent,
    VariableParserInputComponent,
    VerticalSplitResizeDirective,
    SettingsShellComponent,
    Chat,
    ImageCropUploadComponent,
    SearchBarComponent,
    RecordList,
    DatePickerInputComponent,
    SharedActivitySchedulerModal,
    UtcToLocalPipe,
    LocalDateTimePipe,
    RelativeDatePipe,
    LocalDatePipe,
    PaginationComponent,
    SafeSvgPipe,
    ProductVariantPicker,
    PipelineTracker,
    TaxSelector,
    MoneyInput,
    FloatingDropdownComponent,
    TabulatedForm,
    PageBackButtonComponent,
    AnalyticDistributionInput,
    PartnersSelect,
    BusinessDocumentEvents,
    CountrySelect,
    RegionSelect,
    CitySelect,
    AddressAutocomplete,
    AnalyticDistributionModelNewModal,
    AutosaveStatus,
    CurrencySelect,
    VerificationDrawer,
    BusinessDocumentView,
    ListSelectionDirective,
    TableCellOverflowTitleDirective,
    TimezoneSelect,
    BusinessDocumentKanban,
    BusinessDocumentViewToggle,
    LinkedRecordStatus,
    ViewModeToggle,
    Alerts,
    GlobalAlert,
    OpenRouterLinkInNewTab,
    EmployeeGroupMemberFiltersInput,
    BusinessDocumentPipelinePicker,
    ProductLines,
    AiModelConnectionForm,
    AiComposer,
    BusinessDocumentWrapper,
    BusinessDocumentNextButtons,
    BusinessDocumentContributorModal,
    RealtimeToasts,
    ProjectCard,
    AppMenu,
    BusinessDocumentEmailDrawer,
    BusinessDocumentChatDrawer,
    MessageList,
    MessageView,
    AiChat,
    ProductItemPicker,
    AiMarkdownPipe,
    AiMessage,
    AiConversationList,
    AiModelConnectionsPage,
    JournalEntryLines,
    SingleImageInput,
  ],
  imports: [
    ConfirmationDialog,
    A11yModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    MatDialogModule,
    DragDropModule,
    OverlayModule,
    NgxMaterialIntlTelInputComponent,
    WidgetAndGraphsModule,
    Information,
    InformationPanel,
  ],
  exports: [
    ConfirmationDialog,
    SingleImageInput,
    Information,
    InformationPanel,
    Footer,
    Header,
    Wrapper,
    RouterModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    DragDropModule,
    OverlayModule,
    ReactiveFormsModule,
    PhoneInput,
    TomSelectComponent,
    AutocompleteSelectComponent,
    RqlSelect,
    TerminalLogComponent,
    FormsModule,
    VariableParserInputComponent,
    VerticalSplitResizeDirective,
    SettingsShellComponent,
    ImageCropUploadComponent,
    SearchBarComponent,
    RecordList,
    DatePickerInputComponent,
    SharedActivitySchedulerModal,
    UtcToLocalPipe,
    LocalDateTimePipe,
    RelativeDatePipe,
    LocalDatePipe,
    PaginationComponent,
    SafeSvgPipe,
    ProductVariantPicker,
    PipelineTracker,
    TaxSelector,
    MoneyInput,
    FloatingDropdownComponent,
    TabulatedForm,
    PageBackButtonComponent,
    AnalyticDistributionInput,
    PartnersSelect,
    BusinessDocumentEvents,
    CountrySelect,
    RegionSelect,
    CitySelect,
    AddressAutocomplete,
    AutosaveStatus,
    AnalyticDistributionModelNewModal,
    CurrencySelect,
    VerificationDrawer,
    BusinessDocumentView,
    ListSelectionDirective,
    TableCellOverflowTitleDirective,
    TimezoneSelect,
    BusinessDocumentKanban,
    BusinessDocumentViewToggle,
    LinkedRecordStatus,
    ViewModeToggle,
    Alerts,
    GlobalAlert,
    OpenRouterLinkInNewTab,
    EmployeeGroupMemberFiltersInput,
    BusinessDocumentPipelinePicker,
    ProductLines,
    JournalEntryLines,
    AiModelConnectionForm,
    AiComposer,
    BusinessDocumentWrapper,
    BusinessDocumentNextButtons,
    BusinessDocumentContributorModal,
    WidgetAndGraphsModule,
    ProjectCard,
    AppMenu,
    MessageList,
    MessageView,
    ProductItemPicker,
    AiMarkdownPipe,
    AiMessage,
    AiConversationList,
    AiModelConnectionsPage,
  ]
  ,
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
